
//
const serviceButtons = document.querySelectorAll('.service-button[data-service="total-landlord-insurance"]');

if (serviceButtons !== undefined && serviceButtons.length > 0) {

    //
    const zenoFetch     = require('../utils/zenoFetch.js');
    const createElement = require('../utils/createElement.js');

    //
    for (const serviceButton of serviceButtons) {

        //toggle the information panel as needed
        serviceButton.addEventListener('click', function(event) {
            if (event.target.matches('[data-action="toggle-service-information"]') == true) {
                event.target.closest('.service-button').setAttribute('data-show-service-information', ((serviceButton.dataset.showServiceInformation == 'no') ? 'yes' : 'no'));
            }
        });

        //
        serviceButton.querySelector('button[data-action="get-total-landlord-insurance-service-token"]').addEventListener('click', async function(event) {

            //
            if (event.target.disabled == true) {
                return false;
            }

            //
            event.target.disabled = true;

            //
            serviceButton.classList.add('service-button-loading');
            serviceButton.classList.remove('service-button-error');

            //
            event.target.setAttribute('data-loading', 'data-loading');          

            //
            const [ status, response ] = await zenoFetch('post', '/api/get-total-landlord-insurance-service-token');

            //
            if (status == 'success') {
                window.location = response.redirectTo;
                return;
            }

            //
            event.target.disabled = false;

            //
            serviceButton.classList.remove('service-button-loading');
            serviceButton.classList.add('service-button-error');
            
            //
            event.target.removeAttribute('data-loading'); 

            //add an error message to the widget
            const serviceButtonButtonContainer = serviceButton.querySelector('.service-button-button');
            serviceButtonButtonContainer.insertAdjacentElement('beforeend', createElement('p', {}, response.message ?? 'An unknown error has occurred.'));

        });

    }

}